// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes randomPulseShadow {
  0% {
    box-shadow: 0 2px 25px var(--color-primaryMedium);
  }
  20% {
    box-shadow: 0 5px 30px var(--color-primaryMedium);
  }
  40% {
    box-shadow: 0 3px 20px var(--color-primaryMedium);
  }
  60% {
    box-shadow: 0 6px 35px var(--color-primaryMedium);
  }
  80% {
    box-shadow: 0 4px 28px var(--color-primaryMedium);
  }
  100% {
    box-shadow: 0 2px 25px var(--color-primaryMedium);
  }
}

.bubble-card-container {
  padding: 10px 0px 20px 0px;
  box-shadow: 0 2px 25px var(--color-primaryMedium);
  background-color: var(--color-grey000);
  border-radius: 10px;
  animation: randomPulseShadow 10s ease-in-out infinite; /* Longer duration for a more random feel */
}

.bubble-card-title-block {
  padding: 10px;
  display: flex;
  flex-direction: column; /* Stacks title and subtitle vertically */
  align-items: center; /* Centers both title and subtitle */
  justify-content: center;
}

.bubble-card-title {
  color: var(--color-primaryMedium);
  font-weight: bold;
  font-size: 24pt;
  text-align: center;
  margin-bottom: 5px; /* Adds spacing between title and subtitle */
}

.bubble-card-subtitle {
  color: var(--color-primaryMedium);
  font-weight: normal; /* Use lighter font-weight for subtitle */
  font-size: 10pt; /* Slightly smaller font-size for subtitle */
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/BubbleCard.css"],"names":[],"mappings":"AAAA;EACE;IACE,iDAAiD;EACnD;EACA;IACE,iDAAiD;EACnD;EACA;IACE,iDAAiD;EACnD;EACA;IACE,iDAAiD;EACnD;EACA;IACE,iDAAiD;EACnD;EACA;IACE,iDAAiD;EACnD;AACF;;AAEA;EACE,0BAA0B;EAC1B,iDAAiD;EACjD,sCAAsC;EACtC,mBAAmB;EACnB,qDAAqD,EAAE,2CAA2C;AACpG;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB,EAAE,yCAAyC;EACjE,mBAAmB,EAAE,oCAAoC;EACzD,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,kBAAkB,EAAE,4CAA4C;AAClE;;AAEA;EACE,iCAAiC;EACjC,mBAAmB,EAAE,yCAAyC;EAC9D,eAAe,EAAE,4CAA4C;EAC7D,kBAAkB;AACpB","sourcesContent":["@keyframes randomPulseShadow {\n  0% {\n    box-shadow: 0 2px 25px var(--color-primaryMedium);\n  }\n  20% {\n    box-shadow: 0 5px 30px var(--color-primaryMedium);\n  }\n  40% {\n    box-shadow: 0 3px 20px var(--color-primaryMedium);\n  }\n  60% {\n    box-shadow: 0 6px 35px var(--color-primaryMedium);\n  }\n  80% {\n    box-shadow: 0 4px 28px var(--color-primaryMedium);\n  }\n  100% {\n    box-shadow: 0 2px 25px var(--color-primaryMedium);\n  }\n}\n\n.bubble-card-container {\n  padding: 10px 0px 20px 0px;\n  box-shadow: 0 2px 25px var(--color-primaryMedium);\n  background-color: var(--color-grey000);\n  border-radius: 10px;\n  animation: randomPulseShadow 10s ease-in-out infinite; /* Longer duration for a more random feel */\n}\n\n.bubble-card-title-block {\n  padding: 10px;\n  display: flex;\n  flex-direction: column; /* Stacks title and subtitle vertically */\n  align-items: center; /* Centers both title and subtitle */\n  justify-content: center;\n}\n\n.bubble-card-title {\n  color: var(--color-primaryMedium);\n  font-weight: bold;\n  font-size: 24pt;\n  text-align: center;\n  margin-bottom: 5px; /* Adds spacing between title and subtitle */\n}\n\n.bubble-card-subtitle {\n  color: var(--color-primaryMedium);\n  font-weight: normal; /* Use lighter font-weight for subtitle */\n  font-size: 10pt; /* Slightly smaller font-size for subtitle */\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
